import { initialSelectionState } from '../../core/components/annotations/providers/AnnotationsDataInitialState.js';
import type { PointsDisplay } from '../../core/components/canvas/types/canvas-shape.js';
import { TRUNCATION_MODE } from '../../core/components/legend/range/constants.js';
import { defaultRatio } from '../../core/constants.js';
import type { XYChartState } from '../types/state.js';
import {
  XYChartAxisProps,
  XYChartChartLegendProps,
  XYChartConfigProperties,
  XYChartNumericalAxisProps,
  XYChartToolbarConfigProps,
} from '../types/xy-chart-props.js';

export const DEFAULT_CHART_HEIGHT = 300;

export const DEFAULT_COLOR_PALETTE = 'categorical';
export const DEFAULT_COLOR_PALETTE_RECT = 'blue';

export const DEFAULT_LOADING_STATE = false;

type XYChartAxisDefaults = Pick<XYChartAxisProps, 'hidden' | 'reversed'> &
  Pick<XYChartNumericalAxisProps, 'min' | 'max'>;

export const DEFAULT_AXIS_CONFIG: XYChartAxisDefaults = {
  hidden: false,
  min: 'auto',
  max: 'auto',
  reversed: false,
};

export const DEFAULT_LEGEND_RANGE_FORMATTER = {
  maximumFractionDigits: 1,
};

export const initialState: XYChartState = {
  zoom: {
    zoomInEnabled: true,
    zoomOutEnabled: false,
  },
  currentDomain: undefined,
  select: undefined,
  interactionMode: 'explore',
  thresholds: { hoveredThresholdId: undefined },
  highlightedSeriesId: undefined,
  filteredSeriesIds: undefined,
  annotations: initialSelectionState,
};

export const defaultLegend: XYChartChartLegendProps = {
  hidden: false,
  position: 'auto',
  ratio: defaultRatio,
} as const;

export const defaultToolbar: XYChartToolbarConfigProps = {
  hidden: false,
  placement: 'top-right',
  collapsed: false,
  draggable: true,
} as const;

export const defaultConfig: XYChartConfigProperties = {
  legend: defaultLegend,
  toolbar: defaultToolbar,
  colorPalette: undefined,
  truncationMode: TRUNCATION_MODE.Middle,
  thresholdIndicators: [],
  yAxes: [],
  xAxes: [],
  colorRules: [],
};

export const XY_CHART_ARIA_LABEL = 'XY Chart';
/** Annotations bottom padding in pixels */
export const ANNOTATIONS_PADDING_BOTTOM = 6;

export const DISPLAY_UNITS_LIMIT = 3;

export const DEFAULT_POINTS_DISPLAY = 'auto' as PointsDisplay;

export const RECT_STROKE_WIDTH = 1;

export const XY_CHART_BOTTOM_AXIS_LABEL = 'Bottom axis';

export const XY_CHART_TOP_AXIS_LABEL = 'Top axis';

export const DISPLAY_NAME = 'XYChart';
